/** @jsxImportSource @emotion/react */
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Form, Modal } from "antd";
import { RegisterFormType } from "api/auth/type";
import InputCustom from "components/base/InputCustom";
import InputPassword from "components/base/InputPassword";
import InputPhoneNumber from "components/base/InputPhoneNumber";
import { REGEX_PASSWORD, REGEX_USERNAME } from "constants/regex";
import { ResponseCode } from "constants/response";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useFacebookPixel } from "hooks/useFacebookPixel";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { selectIsLoading } from "store/auth";
import { registerMemberDetail } from "store/auth/auth.thunk";
import { setOpenModal } from "store/modal";
import { outletContextType } from "types";
import { ApiResponse } from "types/api";
import { ModalTypeValue } from "types/modal";
import * as yup from "yup";

import WrapperForm from "../WrapperForm";
import { RegisterModalStyle } from "./index.style";

interface props {
  code: string | null;
}
function RegisterModal({ code }: props) {
  const { openNotification } = useOutletContext<outletContextType>();
  // const [countdownOTP, setCoundownOTP] = useState<number>(0);
  // const [isDisableBtnOTP, setIsDisableBtnOTP] = useState<boolean>(true);
  // const username =
  //   useAppSelector(selectUsername) || localStorage.getItem("username");
  const { t } = useTranslation(["common", "register"]);
  const pixelId = "1165203495329596";
  const accessToken =
    "EAAOY9rtrjZAkBOyiI7Bm5FNEOzAzaSUV3l8Qz5Q7Szoaub6j6ZBnTihuEW0TBoNSIlZAXZA6TOX43vxnLk2ZBWkxGZCEnUtweFJtDVMyHUG7E9uq51VZAZA2KZB89BbtnhuAnumoRfdNBZAZApG5fXJor9MIIMAisspIwAZCtraxxEeosnpz2IoADQmkqLK0o3fZAxDGx6wZDZD";

  useFacebookPixel(pixelId);
  const sendEventToFacebook = async () => {
    const eventData = {
      data: [
        {
          event_name: "PageView",
          event_time: Math.floor(Date.now() / 1000),
          user_data: {
            client_user_agent: navigator.userAgent
          },
          action_source: "website"
        }
      ]
    };

    await fetch(
      `https://graph.facebook.com/v22.0/${pixelId}/events?access_token=${accessToken}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(eventData)
      }
    );
  };

  // useEffect(() => {
  //   let timer: NodeJS.Timeout | null = null;

  //   if (countdownOTP > 0) {
  //     timer = setInterval(() => {
  //       setCoundownOTP((prev) => prev - 1);
  //     }, 1000);
  //   } else if (countdownOTP === 0) {
  //     setIsDisableBtnOTP(false);
  //   }

  //   return () => {
  //     if (timer) clearInterval(timer);
  //   };
  // }, [countdownOTP]);

  useEffect(() => {
    sendEventToFacebook();
  }, []);

  const schema = yup
    .object({
      username: yup
        .string()
        // .trim()
        .max(12, t("register:Max12"))
        .matches(REGEX_USERNAME, t("register:username_mobile_validation"))
        .required(t("register:username_required")),

      mobile: yup
        .string()
        .min(10, t("register:Min"))
        .max(14, t("register:Max"))
        .trim()
        .required(t("register:username_required")),
      // mobile: yup.string().trim().required(t("register:mobile_required")),
      // email: yup.string().trim().email().required(t("register:email_required")),
      password: yup
        .string()
        .trim()
        .matches(REGEX_PASSWORD, t("register:password_validation"))
        .required(t("register:password_required")),
      confirm_password: yup
        .string()
        .trim()
        .matches(REGEX_PASSWORD, t("register:password_validation"))
        .required(t("register:password_required"))
      // otp: yup
      //   .string()
      //   .length(6, t("register:OTPLenght"))
      //   .required(t("register:FieldRequired"))
    })
    .required();
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector(selectIsLoading);

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isValid }
  } = useForm<RegisterFormType>({
    resolver: yupResolver<any>(schema),
    mode: "all"
  });

  useEffect(() => {
    if (code) {
      setValue("referral", code);
    }
  }, []);
  // const areaCodeValidate = (number: string) => {
  //   if (number.startsWith("+")) {
  //     number = number.slice(1);
  //   }
  //   if (number.startsWith("0")) {
  //     return "880" + number.slice(1);
  //   }

  //   if (number.slice(0, 3) !== "880") {
  //     return "880" + number;
  //   }
  //   return number;
  // };

  const onSubmit = async (data: RegisterFormType) => {
    const dataForm = {
      ...data,
      username: data.username,
      fullname: data.username
    };
    const res = await dispatch(registerMemberDetail(dataForm));

    const resData = res.payload as ApiResponse;

    if (resData.status !== ResponseCode.SUCCESS) {
      openNotification("error", res.payload as string);
      return;
    }

    dispatch(setOpenModal(ModalTypeValue.Close));
  };

  // const handleGetOTP = async () => {
  //   const mobile = getValues("mobile");
  //   if (!mobile)
  //     return openNotification("error", t("register:requiredOTPPhone"));
  //   setCoundownOTP(60);
  //   setIsDisableBtnOTP(true);

  //   const dataRequest: RequestOTPType = {
  //     username: String(username),
  //     mobile: mobile,
  //     type: TypeRequestOtpCode.Registration
  //   };

  //   const res = await AuthApi.requestOTP(dataRequest);
  //   if (res.status === ResponseCode.SUCCESS) {
  //     // setCoundownOTP(300);
  //     setIsDisableBtnOTP(true);
  //     openNotification("success", res.msg);
  //   } else {
  //     openNotification("success", res.msg);
  //   }
  // };

  return (
    <Modal
      open={true}
      closable={false}
      onCancel={() => dispatch(setOpenModal(ModalTypeValue.Close))}
      css={RegisterModalStyle.modalContainer}
      footer={<></>}
      centered
    >
      <WrapperForm
        title={t("register:title")}
        formType={ModalTypeValue.Register}
        body={
          <div css={RegisterModalStyle.formContainer}>
            <Form
              css={RegisterModalStyle.formContainer}
              onSubmitCapture={handleSubmit(onSubmit)}
              autoComplete="off"
            >
              <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:username_label")}</label>
                <InputCustom
                  disabled={isLoading}
                  placeholder={t("register:username_placeholder")}
                  name={"username"}
                  margin_bottom="0px"
                  control={control}
                  errors={errors.username?.message}
                  validate_status={errors.username ? "error" : "success"}
                />
              </div>
              <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:password_label")}</label>
                <InputPassword
                  disabled={isLoading}
                  placeholder={t("register:password_placeholder")}
                  name={"password"}
                  control={control}
                  margin_bottom="0px"
                  error={errors.password?.message}
                  validate_status={errors.password ? "error" : "success"}
                />
              </div>
              <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:confirm_password_label")}</label>
                <InputPassword
                  disabled={isLoading}
                  placeholder={t("register:confirm_password_placeholder")}
                  name={"confirm_password"}
                  control={control}
                  margin_bottom="0px"
                  autoComplete="new-password"
                  error={errors.confirm_password?.message}
                  validate_status={
                    errors.confirm_password ? "error" : "success"
                  }
                />
              </div>
              {/* <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:email_label")}</label>
                <InputCustom
                  disabled={isLoading}
                  placeholder={t("register:email_placeholder")}
                  name={"email"}
                  margin_bottom="0px"
                  control={control}
                  errors={errors.email?.message}
                  validate_status={errors.email ? "error" : "success"}
                />
              </div> */}
              <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:mobile_label")}</label>
                <InputPhoneNumber
                  disabled={isLoading}
                  name={"mobile"}
                  control={control}
                  margin_bottom="0px"
                  error={errors.mobile?.message}
                  validate_status={errors.mobile ? "error" : "success"}
                  onChange={(val) => {
                    //
                  }}
                />
              </div>
              {/* <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:FullName")}</label>
                <InputCustom
                  disabled={isLoading}
                  placeholder={t("register:FullName")}
                  name={"fullname"}
                  margin_bottom="0px"
                  control={control}
                  errors={errors.fullname?.message}
                  validate_status={errors.fullname ? "error" : "success"}
                />
              </div> */}
              {/* <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:otp")}</label>
                <div className="group">
                  <InputCustom
                    disabled={isLoading}
                    placeholder={t("register:otp_placeholder")}
                    name={"otp"}
                    margin_bottom="0px"
                    control={control}
                    errors={errors.otp?.message}
                    validate_status={errors.otp ? "error" : "success"}
                  />
                  <button
                    type="button"
                    className="btn-getOtp"
                    onClick={handleGetOTP}
                    disabled={isDisableBtnOTP}
                  >
                    {countdownOTP > 0
                      ? `${Math.floor(countdownOTP / 60)}:${String(
                          countdownOTP % 60
                        ).padStart(2, "0")}`
                      : t("register:GetOTP")}
                  </button>
                </div>
              </div> */}

              <div css={RegisterModalStyle.inputControl}>
                <label>{t("register:referral_label")}</label>
                <InputCustom
                  disabled={isLoading || !!code}
                  placeholder={t("register:referral_placeholder")}
                  name={"referral"}
                  margin_bottom="0px"
                  control={control}
                  errors={errors.referral?.message}
                  validate_status={errors.referral ? "error" : "success"}
                />
              </div>

              <Button
                disabled={!isValid}
                loading={isLoading}
                css={[
                  RegisterModalStyle.buttonSubmit,
                  isValid && RegisterModalStyle.buttonActive
                ]}
                htmlType="submit"
              >
                {t("register:submit_button")}
              </Button>
            </Form>
          </div>
        }
        footer={
          <div css={RegisterModalStyle.footer}>
            <p>
              {t("register:already_account")}{" "}
              <span
                onClick={() => dispatch(setOpenModal(ModalTypeValue.Login))}
              >
                {t("register:go_to_login")}
              </span>
            </p>
          </div>
        }
      />
    </Modal>
  );
}

export default RegisterModal;
